// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","455":"9adbb07a","549":"4b51edde","687":"92db8599","977":"4db89900"}[chunkId] + ".chunk.js";
};